/*
 * @描叙: 解析定时管理数据 
 * @作者: hanlaifu 
 * @公司: 春梅信息 
 * @创建时间: 2019-03-28 15:38:00 
*/
export default function parseTimerData(data, sysid) {
    let timeDesc = {}, 
        settingTime ={} ,
        timeControlMeters = {}, 
        timeControlForm ={};
        // 定时信息
    timeDesc.oid = data.OID
    timeDesc.timername = data.Timername
    timeDesc.enable = data.Enable
    timeDesc.devtype = data.Devtype
    timeDesc.description = data.Description
    timeDesc.Timerkind = data.Timerkind

    // 定时日期
    let TimerTime = JSON.parse(data.TimerTime);
    if (TimerTime.type === 'day') {
        settingTime.value4 = true;
        settingTime.dates = TimerTime.data.map(v => { return v.value});
    } 
    if (TimerTime.type === 'week') {
        settingTime.value4 = false;
        settingTime.ckeckList = TimerTime.data.map(v => { return v.value });
    }
    settingTime.time = TimerTime.time;

    // 控制对象
    let Timer_control_dev = JSON.parse(data.TimerControlDev);
    timeControlMeters.type = Timer_control_dev.type
    if (Timer_control_dev.type == 1) {
        // 控制单个表计
        timeControlMeters.OID = Timer_control_dev.data[0].value
    }
    if (Timer_control_dev.type == 2) {
        // 控制分组
        timeControlMeters.groupValue = Timer_control_dev.data.map(v=>{return v.value})
    }
    if (Timer_control_dev.type == 3) {
        // 控制全部设备

    }
    let Timer_control_value = JSON.parse(data.TimerControlValue);
    let timer_control_value = {}
    
    Timer_control_value.map(v=>{
        let K = v["N"];
        let V = v["V"];
        timer_control_value[K] = V;
    })
    timeControlForm = timer_control_value;

    return { timeControlForm, timeControlMeters, timeDesc, settingTime}
}
